import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  AdminCarBatch,
  AdminCarResponse,
  AdminCar,
  CarsDataService,
} from '@mol-limo-reg/admin-api';

@Injectable({
  providedIn: 'root',
})
export class CarService {
  constructor(private readonly carsDataService: CarsDataService) {}

  public getCars$(limit: number, offset: number, q?: string): Observable<AdminCarBatch> {
    return this.carsDataService.getCars(limit, offset, q, 'body');
  }

  public getCarByKey$(modelId: string): Observable<AdminCarResponse> {
    return this.carsDataService.getCarByKey(modelId, 'body');
  }

  public updateCarByKey$(modelId: string, data: AdminCar, file?: Blob): Observable<AdminCarResponse | null> {
    return this.carsDataService.updateCarByKey(modelId, data, file, 'body');
  }

  public deleteCarAssetByKey$(modelId: string): Observable<any> {
    return this.carsDataService.deleteCarAssetByKey(modelId, 'body');
  }
}
